import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = {
  class: "d-sm-flex align-items-center",
  style: {"width":"100%"}
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-4" }
const _hoisted_6 = { class: "form-group mb-15 mt-30 mb-sm-20 mb-md-25" }
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_12 = { class: "table-responsive" }
const _hoisted_13 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_20 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          ref: "etatForm",
          "validation-schema": _ctx.etatSchema,
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_Field, {
                    name: "recherche",
                    type: "text",
                    modelValue: _ctx.recherche,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.recherche) = $event)),
                    style: {"margin-top":"30px"},
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: "Rechercher"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "recherche",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date Début ", -1)),
                  _createVNode(_component_Field, {
                    name: "debut",
                    type: "date",
                    modelValue: _ctx.debut,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.debut) = $event)),
                    style: {"background-color":"#fff"},
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: "Choisisser la date"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "debut",
                    class: "text-danger"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Date Fin ", -1)),
                  _createVNode(_component_Field, {
                    name: "fin",
                    modelValue: _ctx.fin,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fin) = $event)),
                    type: "date",
                    style: {"background-color":"#fff"},
                    class: "form-control shadow-none fs-md-15 text-black",
                    placeholder: "Choisisser la date"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_ErrorMessage, {
                    name: "fin",
                    class: "text-danger"
                  })
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["validation-schema"])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("table", _hoisted_13, [
          _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Ref.Liv "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Date.Liv "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Ref.Cmd "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Date.Cmd "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Produit "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Client "),
              _createElementVNode("th", {
                scope: "col",
                class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              }, " Qté.Liv ")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produits, (prod, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_14, _toDisplayString(prod?.livraison?.refLiv || 'N/A'), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString(prod?.livraison?.dateLiv ? _ctx.format_Date(prod.livraison.dateLiv) : 'N/A'), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(prod?.livraison?.commandeClient?.refCom || 'N/A'), 1),
                _createElementVNode("td", _hoisted_17, _toDisplayString(prod?.livraison?.commandeClient?.dateCommande ?
                                    _ctx.format_Date(prod.livraison.commandeClient.dateCommande) : 'N/A'), 1),
                _createElementVNode("td", _hoisted_18, _toDisplayString(prod?.proCondiCommandeClient?.produitConditionnement?.produit?.nomProd || 'N/A') + " [" + _toDisplayString(prod?.proCondiCommandeClient?.produitConditionnement?.conditionnement?.code || '') + "] ", 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.getNomClient(prod?.livraison?.commandeClient?.client)), 1),
                _createElementVNode("td", _hoisted_19, _toDisplayString(prod?.qtite || 0), 1)
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}